import { render, staticRenderFns } from "./release-details.vue?vue&type=template&id=c6cd6778"
import script from "./release-details.vue?vue&type=script&lang=js"
export * from "./release-details.vue?vue&type=script&lang=js"
import style0 from "./release-details.vue?vue&type=style&index=0&id=c6cd6778&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports